import { Heading3, StackView, Text } from 'localmed-core';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import DILetter from '../../../shared/icons/DI/DiLetter';
import { IStepProps } from '../../pages/SchedulingPage/components/schedulingWizard';
import { ContentWrapper, Wrapper } from '../../pages/SchedulingPage/components/styles';

interface Props extends IStepProps {
  redirect?: boolean;
}

export default function SchedulingAppointmentVerify({ wizard }: Props) {
  useEffect(() => {
    if (wizard?.trackSchedulingEvent) {
      wizard.trackSchedulingEvent(
        'Scheduling Appointment Verification',
        'SchedulingAppointmentVerify'
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!wizard) return null;

  const { contactEmail, provider } = wizard.values;
  return (
    <Wrapper justifyContent="center" alignItems="center">
      <ContentWrapper textAlign="center">
        <StackView spacing="md">
          <DILetter />

          <Heading3>
            <FormattedMessage
              id="scheduling.SchedulingAppointmentVerify.bookingInProgressMessage"
              defaultMessage="We can’t schedule your appointment until you verify your email."
            />
          </Heading3>
          <Text>
            <FormattedMessage
              id="scheduling.SchedulingAppointmentVerify.bookingInProgressMessage"
              defaultMessage="We sent an email to {contactEmail} to verify your appointment with {providerDisplay}."
              values={{
                contactEmail,
                providerDisplay: provider?.display,
              }}
            />
          </Text>
        </StackView>
      </ContentWrapper>
    </Wrapper>
  );
}

SchedulingAppointmentVerify.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  id: 'SCHEDULING_APPOINTMENT_VERIFY',
};
